import { render } from "./accounting.vue?vue&type=template&id=2570db39"
import script from "./accounting.vue?vue&type=script&lang=js"
export * from "./accounting.vue?vue&type=script&lang=js"

import "./accounting.vue?vue&type=style&index=0&id=2570db39&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__